// Phone helpers — country dialling code per UI language and a sanitiser that
// keeps inputs numeric-only (with optional leading "+").

const DIAL_CODES = {
  tr: { code: '+90', placeholder: '+90 5xx xxx xx xx' },
  en: { code: '+44', placeholder: '+44 7xxx xxxxxx' },
  ru: { code: '+7', placeholder: '+7 9xx xxx xx xx' },
  no: { code: '+47', placeholder: '+47 4xx xx xxx' },
  de: { code: '+49', placeholder: '+49 1xx xxxxxxx' },
};

export const getDialInfo = (lang) => DIAL_CODES[lang] || DIAL_CODES.en;

export const getPhonePlaceholder = (lang) => getDialInfo(lang).placeholder;

export const getDialCode = (lang) => getDialInfo(lang).code;

// Allow only "+", digits and a single space between groups; cap to 18 chars.
export const sanitizePhoneInput = (raw) => {
  if (!raw) return '';
  let v = String(raw).replace(/[^\d+ ]/g, '');
  // Only one leading "+", strip any inner "+"
  if (v.startsWith('+')) {
    v = '+' + v.slice(1).replace(/\+/g, '');
  } else {
    v = v.replace(/\+/g, '');
  }
  // Collapse multiple spaces
  v = v.replace(/\s{2,}/g, ' ');
  return v.slice(0, 18);
};
